import * as ng from 'angular';
import { UISelectService } from '../../../../services/ui-select.service';
import { ArchiSmallServices } from '../../../../services/archismall.service';

class AnagraficaInTdocContoller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices',
        '$sce',
        '$filter',
        'UiSelectService'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices,
        private $sce: ng.ISCEService,
        private $filter: ng.IFilterService,
        private UISelectService: UISelectService,
    ) {
        $scope.pageHeader = 'Anagrafica in tDOC';
        $scope.pageSubHeader = 'Scegli l\'utente per creazione Anagrafica in tDOC';
        $scope.users = [{user: ''}];
        $rootScope.formsubmitted = false;

        $scope.trustAsHtml = (value) => {
            return $sce.trustAsHtml(value);
        };

        $scope.getUsersTypeaheadValues = () => {
            ArchiSmallServices.getUsers()
                .then((response: any) => {
                  response = response.reverse().map(item => { return {email: item.accountData.email,
                    piva: item.organizationData.PIVA, company_name: item.organizationData.name ||
                      (item.organizationData.contactPerson.firstname + ' ' + item.organizationData.contactPerson.surname), _id: item._id}; });
                  response.unshift({email: 'create_all_accounts@archismall.it', piva: 'Tutti utenti',
                    company_name: 'Tutti utenti', _id: '-'});
                  $scope.anagrafica = response;
                    console.log(response);
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        $scope.getUsersTypeaheadValues();

        $scope.refreshResults = ($select) => {
            UISelectService.refreshResults($select);
        };

        // <editor-fold desc='openAnagraficaInTdocModal'>
        $scope.openAnagraficaInTdocModal = (size) => {

            if ($scope.anagraficaIsNew) {
                $scope.saveAnagrafica();
            }

            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'workerAnagraficaInTdocModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                  users: () => {
                    return $scope.users;
                  }
                }
            });
        };
      $scope.addUser = () => {
        $scope.users.push({email: ''});
      };

      $scope.removeUser = (index) => {
        $scope.users.splice(index, 1);
      };
        // </editor-fold>

    }
}

export const AnagraficaInTdocComponent: ng.IComponentOptions = {
    template: require('./anagrafica-in-tdoc.html'),
    controller: AnagraficaInTdocContoller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/anagrafica-in-tdoc/anagrafica-in-tdoc.ts